var exports = {
  "k": "xe564cbfb--c0d78b--container",
};

module.exports = exports;
